export const headerGeneration = (I18n) => {
    return [
        {
            label: ["Data translation"],
            type: "customComponent",
            align: "left",
            editable: false,
            basis: "95%",
        },
        {
            label: [I18n.translate`Actions`],
            type: "customComponent",
            align: "right",
            editable: false,
            basis: "5%",
        },
    ];
};

export const cardGeneration = (data, I18n, editOpen, setEditOpen, setRowIdUpdate, cdmNames, cdmEntity) => {
    const { id, conditions, updates, translationId } = data;
    const conditionsParsed = JSON.parse(conditions);
    const updatesParsed = JSON.parse(updates);
    const translationTableBuilderId = id;

    return [
        [
            {
                labels: ["Data translation"],
                value: {
                    customComponent: "TranslationDetailsSyntaxRow",
                    id,
                    conditionsParsed,
                    updatesParsed,
                },
            },
        ],
        [
            {
                labels: [I18n.translate`Actions`],
                value: {
                    customComponent: "TranslationDetailsMoreAction",
                    id,
                    editOpen,
                    setEditOpen,
                    setRowIdUpdate,
                    conditionsParsed,
                    updatesParsed,
                    cdmNames,
                    translationTableBuilderId,
                    translationId,
                    entity: cdmEntity,
                    message: "Editing this translation will reset the related entities",
                },
            },
        ],
    ];
};

export const onTranslationTableDetailsSave = (
    saveTranslationDetails,
    translationTableBuilderId,
    data,
    pushNotification,
    reload,
    translationId,
    setEditOpen,
    combination,
    related_entities,
) => {
    return saveTranslationDetails(translationTableBuilderId, JSON.stringify(data), translationId, combination, related_entities)
        .then((res) => {
            if (!res?.update_translation_builder?.success) {
                pushNotification({
                    open: true,
                    message: `Somethings went wrong`,
                    type: "error",
                    timeout: "short",
                });
                return null;
            }
            pushNotification({
                open: true,
                message: `Your changes have been successfully saved.`,
                type: "confirmation",
                timeout: "short",
            });
            reload && reload();
            return res;
        })
        .catch(() => {
            pushNotification({
                open: true,
                message: `Somethings went wrong`,
                type: "error",
                timeout: "short",
            });
            return null;
        })
        .finally(() => {
            setEditOpen({ status: false });
        });
};

export const generateCsvWarningCard = (showErrorLines) => {
    if (!showErrorLines) {
        return [];
    }

    return showErrorLines.map((elem, index) => {
        return {
            ...elem,
            id: index,
            card: [
                {
                    labels: [elem],
                    value: elem,
                    type: "string",
                },
            ],
        };
    });
};